import Paperwork from './Paperwork';

export default Paperwork;
